(() => {
  if (window.productMetadataLinksInitialized) return;
  window.productMetadataLinksInitialized = true;

  const resolvableLinkSelector = '[data-metadata-filter-resolve]';
  const filterGroupSelector = '.search-page__filter-group';

  const normalizeLabel = (value) => value.trim().toLocaleLowerCase();

  const optionLabel = (option) => {
    if (option.dataset.label) return option.dataset.label;

    return (option.textContent || '').replace(/\s+\([\d,]+\)\s*$/u, '').trim();
  };

  const canonicalFilterValue = (documentFragment, parameterName, displayLabel) => {
    const normalizedDisplayLabel = normalizeLabel(displayLabel);

    for (const group of documentFragment.querySelectorAll(filterGroupSelector)) {
      const namedControl = [...group.querySelectorAll('[name]')].find(
        (control) => control.getAttribute('name') === parameterName
      );
      if (!namedControl) continue;

      const options = [...group.querySelectorAll('option, [data-search-intellitype-option]')];
      const matchingOption = options.find(
        (option) => normalizeLabel(optionLabel(option)) === normalizedDisplayLabel
      );

      if (matchingOption) return matchingOption.value || matchingOption.dataset.value || '';
    }

    return '';
  };

  const navigateWithCanonicalFilter = async (link) => {
    const targetUrl = new URL(link.href, window.location.origin);
    const parameterName = [...targetUrl.searchParams.keys()].find((name) => name.startsWith('filter.'));
    const displayLabel = link.dataset.metadataFilterLabel || '';

    if (!parameterName || !displayLabel) {
      window.location.assign(targetUrl.toString());
      return;
    }

    const facetUrl = new URL(document.documentElement.dataset.searchUrl, window.location.origin);
    facetUrl.searchParams.set('q', '*');
    facetUrl.searchParams.set('type', 'product');

    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewThemeId) facetUrl.searchParams.set('preview_theme_id', previewThemeId);

    try {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 5000);
      const response = await fetch(facetUrl.toString(), {
        credentials: 'same-origin',
        signal: controller.signal
      });
      window.clearTimeout(timeout);
      if (!response.ok) throw new Error(`Filter lookup failed: ${response.status}`);

      const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const canonicalValue = canonicalFilterValue(responseDocument, parameterName, displayLabel);

      if (canonicalValue) targetUrl.searchParams.set(parameterName, canonicalValue);
    } catch (_error) {
      // The original metafield value remains a useful no-JavaScript fallback.
    }

    window.location.assign(targetUrl.toString());
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(resolvableLinkSelector);
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;

    event.preventDefault();
    if (link.dataset.metadataFilterResolving === 'true') return;

    link.dataset.metadataFilterResolving = 'true';
    link.setAttribute('aria-busy', 'true');
    navigateWithCanonicalFilter(link);
  });
})();
